/**
 * Created by eliasmj on 06/11/2014.
 */

angular.module('qkr').controller('MerchantsController', function($scope, appConfig, $window, merchantService, $uibModal,
                                                                 usSpinnerService, appUrl, messageService,
                                                                 businessCatService, countryService, partnerList,
                                                                 gettextCatalog, FormHelper, paginationService,
                                                                 sessionService, subscriptionService, APP_CONSTANT) {
    const merchantsCtrl = this;

    merchantsCtrl.isForbidden = !(appConfig.isMCAdmin || appConfig.isPartner);
    merchantsCtrl.isMCAdmin = appConfig.isMCAdmin;
    merchantsCtrl.isPartner = appConfig.isPartner;
    merchantsCtrl.form = {};
    merchantsCtrl.merchantListLength = 0;
    merchantsCtrl.searchText = null;
    merchantsCtrl.partners = {
        label: partnerList.length === 1 ? '' : 'All Partners',
        selected: partnerList.length === 1 ? partnerList[0].name : '',
        list: partnerList.map(partner => partner.name)
    };
    merchantsCtrl.countries = {}; // Ideally would be null or assigned via DI
    merchantsCtrl.categories = {};
    merchantsCtrl.maxList = {};
    merchantsCtrl.maxList.list = [10, 20, 30, 50];
    merchantsCtrl.maxList.selected = 10;
    merchantsCtrl.maxList.label = merchantsCtrl.maxList.selected;

    merchantsCtrl.sorter = '';
    // Toggle disable all button only shows in non-production environment
    merchantsCtrl.isShowDisableAll = (appConfig.env != 'production');
    merchantsCtrl.disableAll = true;
    merchantsCtrl.disableAllLoading = false;
    merchantsCtrl.disableAllIcon = 'fa fa-toggle-off';

    const formHelper = new FormHelper($scope);

    /* ----------------------------------------------------------------------------------------------*/
    //  Pagination functions

    merchantsCtrl.pageChanged = function(selectedPage, disabled) {
        if (!disabled) {
            merchantsCtrl.loadMerchantList(selectedPage, (selectedPage - 1) * merchantsCtrl.maxList.selected,
                merchantsCtrl.maxList.selected);
        }
    };

    merchantsCtrl.buildPage = function(itemAmount, currentPage, pageSize) {
        merchantsCtrl.pageCtrl = paginationService.getPages(itemAmount, currentPage, pageSize);

        // Set visibility
        merchantsCtrl.isToShowFilterPagination = merchantsCtrl.pageCtrl && merchantsCtrl.pageCtrl.totalItems > 10 &&
            (!merchantsCtrl.merchantList.noResult || !merchantsCtrl.merchantList.loaded);
    };
    /* ----------------------------------------------------------------------------------------------*/

    // TODO when school need to fill the outlet

    merchantsCtrl.startSpin = function() {
        usSpinnerService.spin('spinner-1');
    };
    merchantsCtrl.stopSpin = function() {
        usSpinnerService.stop('spinner-1');
    };

    merchantsCtrl.protractor = appConfig.protractor;

    merchantsCtrl.deleteMerchant = function(name) {
        if (appConfig.env !== 'production') {
            console.log('deleting merchant', name);

            const promise = merchantService.deleteMerchant(name);

            promise.then(() => {
                merchantsCtrl.loadMerchantList();
            }, (reason) => {
                messageService.error('Error Delete Merchant', reason);
            });
        }
    };

    merchantsCtrl.reloadMerchants = function() {
        merchantsCtrl.loadMerchantList(null, null, merchantsCtrl.maxList.selected);
    };

    merchantsCtrl.showClearFilters = function() {
        return merchantsCtrl.partners.selected || merchantsCtrl.countries.selected || merchantsCtrl.categories.selected;
    };

    function clearSelected(filterOptions) {
        return filterOptions.map(filter => Object.assign({}, filter, {selected: ''}));
    }

    merchantsCtrl.clearFilters = function() {
        if (partnerList.length === 1) {
            [merchantsCtrl.countries, merchantsCtrl.categories] =
                clearSelected([merchantsCtrl.countries, merchantsCtrl.categories]);
        } else {
            [merchantsCtrl.countries, merchantsCtrl.partners, merchantsCtrl.categories] =
                clearSelected([merchantsCtrl.countries, merchantsCtrl.partners, merchantsCtrl.categories]);
        }
        merchantsCtrl.reloadMerchants();
    };

    merchantsCtrl.loadMerchantList = function(currentPage, offset, max) {
        merchantsCtrl.merchantList = [];
        merchantsCtrl.merchantList.loaded = false;
        merchantsCtrl.merchantList.noResult = null;
        merchantsCtrl.form.offset = offset || 0;
        merchantsCtrl.form.max = max || 10;
        if (merchantsCtrl.searchText != null) {
            merchantsCtrl.form.searchQuery = merchantsCtrl.searchText.toLowerCase();
        } else {
            merchantsCtrl.form.searchQuery = merchantsCtrl.searchText;
        }
        merchantsCtrl.form.selectedPartner = merchantsCtrl.partners.selected;
        merchantsCtrl.form.selectedCountry = merchantsCtrl.countries.selected;
        merchantsCtrl.form.selectedBusinessCategory = merchantsCtrl.categories.selected;

        countryService.listCountries().then((countries) => {
            merchantsCtrl.countries = {
                label: gettextCatalog.getString('All Countries'),
                selected: merchantsCtrl.form.selectedCountry === null ? '' : merchantsCtrl.form.selectedCountry,
                list: countries.map(c => c.name)
            };
        });

        businessCatService.listBusinessCat().then((businessCategories) => {
            merchantsCtrl.categories.label = gettextCatalog.getString('All Business Categories');
            merchantsCtrl.categories.selected = merchantsCtrl.form.selectedBusinessCategory != null ?
                merchantsCtrl.form.selectedBusinessCategory : '';
            merchantsCtrl.categories.list = [];

            angular.forEach(businessCategories, (categoriesInList) => {
                merchantsCtrl.categories.list.push(categoriesInList.name);
            });
        });

        let allDisableAnalytics = true;
        merchantService.getMerchantList(merchantsCtrl.form).then(
            (promise) => {
                if (promise.length != 0) {
                    merchantsCtrl.merchantList = promise[0];
                    merchantsCtrl.merchantListLength = promise[1];

                    merchantsCtrl.buildPage(merchantsCtrl.merchantListLength, currentPage, max);

                    angular.forEach(merchantsCtrl.merchantList, (merchant) => {
                        merchant.registrationUser = '';
                        merchant.registrationUser = merchant.webUserFirstName + ' ' + merchant.webUserLastName;
                        if (merchant.registrationUser && merchant.registrationUser.length > 1 && merchant.webUserEmail) {
                            merchant.registrationUser = merchant.registrationUser + ' (' + merchant.webUserEmail + ')';
                        } else if (merchant.webUserEmail) {
                            merchant.registrationUser = merchant.webUserEmail;
                        }

                        if (merchant.disableAnalytics == false) {
                            allDisableAnalytics = false;
                        }
                        const accountancyPackageName = merchant.accountancyPackageName;
                        if (APP_CONSTANT.FINANCE1_REPORT === accountancyPackageName) {
                            subscriptionService.executeAction(APP_CONSTANT.SubscriptionService.ADD_PARTNER_REPORT);

                        }
                    });

                    // Check if all merchants are already disabled
                    if (allDisableAnalytics) {
                        merchantsCtrl.disableAll = false;
                    }

                } else {
                    merchantsCtrl.merchantList.noResult = 'No results match your search! Please try another query.';
                    merchantsCtrl.isToShowFilterPagination = false;
                }

                merchantsCtrl.stopSpin();
            }, (reason) => {
                messageService.log('Error to load list merchant', reason);
            }
        );
        merchantsCtrl.merchantList.loaded = true;
    };

    // SWAP
    //TODO refactor here
    merchantsCtrl.merchantAdminLink = function(merchantName) {
        let index = -1;
        angular.forEach(merchantsCtrl.merchantList, (value, key) => {
            if (value.name == merchantName) {
                index = key;
            }
        });

        const merchant = merchantsCtrl.merchantList[index];

        merchantService.loadMerchant(merchant.id).then(() => {
            // set the merchant id for session expired
            sessionService.setMerchantIdSession(merchant.id);
            $window.location.href = appConfig.contextPath + appUrl.merchantAdmin;
        });
    };

    // SWAP
    merchantsCtrl.containRole = function(role) {
        return appConfig.userRoles.indexOf(role) !== -1;
    };

    /** Called when Enter is pressed in search box. If only one merchant is displayed it will go to that merchant. */
    merchantsCtrl.searchEnter = function(merchantList) {
        if (merchantList.length == 1) {
            const merchant = merchantList[0];

            merchantService.loadMerchant(merchant.id).then(
                (response) => {
                    $window.location.href = appConfig.contextPath + appUrl.merchantAdmin;
                },
                (reason) => {
                    messageService.error(gettextCatalog.getString('error to load merchant'), reason);
                }
            );
        }
    };

    merchantsCtrl.setArrow = function(active, reverse) {
        merchantsCtrl.merchantStateArrow = 'fa fa-sort';
        merchantsCtrl.merchantNameArrow = 'fa fa-sort';
        merchantsCtrl.partnerNameArrow = 'fa fa-sort';
        merchantsCtrl.merchantStatusArrow = 'fa fa-sort';
        merchantsCtrl.dateCreatedArrow = 'fa fa-sort';
        merchantsCtrl.businessCategoryNameArrow = 'fa fa-sort';
        merchantsCtrl.countryArrow = 'fa fa-sort';
        merchantsCtrl.outletCountArrow = 'fa fa-sort';
        merchantsCtrl.registrationEmailArrow = 'fa fa-sort';
        merchantsCtrl.defaultScanIdArrow = 'fa fa-sort';
        merchantsCtrl.merchantArrow = 'fa fa-sort';
        merchantsCtrl.percentCompleteArrow = 'fa fa-sort';
        merchantsCtrl.registrationUserArrow = 'fa fa-sort';
        merchantsCtrl.disableAnalyticsArrow = 'fa fa-sort';

        switch (active) {
            case ('merchantState') :
                if (reverse) {
                    merchantsCtrl.merchantStateArrow = 'fa fa-sort-up';
                } else {
                    merchantsCtrl.merchantStateArrow = 'fa fa-sort-down';
                }
                break;
            case ('merchantName') :
                if (reverse) {
                    merchantsCtrl.merchantNameArrow = 'fa fa-sort-up';
                } else {
                    merchantsCtrl.merchantNameArrow = 'fa fa-sort-down';
                }
                break;
            case ('merchantStatus') :
                if (reverse) {
                    merchantsCtrl.merchantStatusArrow = 'fa fa-sort-up';
                } else {
                    merchantsCtrl.merchantStatusArrow = 'fa fa-sort-down';
                }
                break;
            case ('partnerName') :
                if (reverse) {
                    merchantsCtrl.partnerNameArrow = 'fa fa-sort-up';
                } else {
                    merchantsCtrl.partnerNameArrow = 'fa fa-sort-down';
                }
                break;
            case ('dateCreated') :
                if (reverse) {
                    merchantsCtrl.dateCreatedArrow = 'fa fa-sort-up';
                } else {
                    merchantsCtrl.dateCreatedArrow = 'fa fa-sort-down';
                }
                break;
            case ('businessCategoryName') :
                // FIXME businessSettingsName
                if (reverse) {
                    merchantsCtrl.businessCategoryNameArrow = 'fa fa-sort-up';
                } else {
                    merchantsCtrl.businessCategoryNameArrow = 'fa fa-sort-down';
                }
                break;
            case ('outletCount') :
                if (reverse) {
                    merchantsCtrl.outletCountArrow = 'fa fa-sort-up';
                } else {
                    merchantsCtrl.outletCountArrow = 'fa fa-sort-down';
                }
                break;
            case ('country') :
                if (reverse) {
                    merchantsCtrl.countryArrow = 'fa fa-sort-up';
                } else {
                    merchantsCtrl.countryArrow = 'fa fa-sort-down';
                }
                break;
            case ('registrationEmail') :
                if (reverse) {
                    merchantsCtrl.registrationEmailArrow = 'fa fa-sort-up';
                } else {
                    merchantsCtrl.registrationEmailArrow = 'fa fa-sort-down';
                }
                break;
            case ('defaultScanId') :
                if (reverse) {
                    merchantsCtrl.defaultScanIdArrow = 'fa fa-sort-up';
                } else {
                    merchantsCtrl.defaultScanIdArrow = 'fa fa-sort-down';
                }
                break;
            case ('percentComplete') :
                if (reverse) {
                    merchantsCtrl.percentCompleteArrow = 'fa fa-sort-up';
                } else {
                    merchantsCtrl.percentCompleteArrow = 'fa fa-sort-down';
                }
                break;
            case ('registrationUser') :
                if (reverse) {
                    merchantsCtrl.registrationUserArrow = 'fa fa-sort-up';
                } else {
                    merchantsCtrl.registrationUserArrow = 'fa fa-sort-down';
                }
                break;
            case ('disableAnalytics') :
                if (reverse) {
                    merchantsCtrl.disableAnalyticsArrow = 'fa fa-sort-up';
                } else {
                    merchantsCtrl.disableAnalyticsArrow = 'fa fa-sort-down';
                }
                break;
        }
    };

    merchantsCtrl.disableAnalytics = function(merchant) {
        merchant.disableAnalyticsLoading = true;
        merchantService.disableAnalytics(merchant.id, merchant.disableAnalytics).then((response) => {
            const r = formHelper.handleResponse(response);

            merchant.disableAnalyticsLoading = false;
            if (r.isSuccess()) {
                merchant = response.merchant;
            } else {
                merchant.disableAnalytics = !merchant.disableAnalytics;
            }
        });
    };

    merchantsCtrl.confirmDisableAllAnalytics = function() {
        const confirmText = merchantsCtrl.disableAll ? 'Disable' : 'Enable';

        const modalInstance = $uibModal.open({
            template: require('../../templates/common/modalDialog.html'),
            controller: 'commonModalDialogController',
            windowClass: 'fade',
            backdrop: 'static',
            resolve: {
                title() {
                    return gettextCatalog.getString(confirmText + ' All Merchants Analytics');
                },
                confirmButtonName() {
                    return gettextCatalog.getString(confirmText);
                },
                confirmMsg() {
                    return gettextCatalog.getString('Are you sure you want to apply this to all merchants?');
                },
                multiMsgArray() {
                    return [];
                }
            }
        });

        modalInstance.result.then((result) => {
            if (result == 'ok') {
                merchantsCtrl.disableAllAnalytics();
            }
        }, () => {
        });
    };

    merchantsCtrl.disableAllAnalytics = function() {
        merchantsCtrl.disableAllLoading = true;
        angular.forEach(merchantsCtrl.merchantList, (merchant) => {
            merchant.disableAnalyticsLoading = true;
        });

        const disableAll = merchantsCtrl.disableAll;

        if (merchantsCtrl.disableAll) {
            merchantsCtrl.disableAllIcon = 'fa fa-toggle-on';
            merchantsCtrl.disableAll = false;
        } else {
            merchantsCtrl.disableAllIcon = 'fa fa-toggle-off';
            merchantsCtrl.disableAll = true;
        }

        merchantService.disableAllAnalytics(disableAll).then((response) => {
            const r = formHelper.handleResponse(response);

            merchantsCtrl.disableAllLoading = true;
            angular.forEach(merchantsCtrl.merchantList, (merchant) => {
                merchant.disableAnalyticsLoading = false;

                if (r.isSuccess()) {
                    merchant.disableAnalytics = disableAll;
                } else {
                    merchant.disableAnalytics = !merchant.disableAnalytics;
                }
            });
            merchantsCtrl.disableAllLoading = false;
        });
    };

    merchantsCtrl.showCreateMerchant = function() {
        if(appConfig.isPartner) {
            const partner = partnerList.find(partner => partner.name == merchantsCtrl.partners.selected);
            if (partner && partner.allowedCreateMerchant != null) {
                return partner.allowedCreateMerchant
            }
        }
        return true;
    };

    merchantsCtrl.checkPermission = function() {
        if(merchantsCtrl.isForbidden) {
            $window.location.href = appConfig.logoutUrl + '?timeout=true';
        }
    };

    const init = function() {
        merchantsCtrl.checkPermission();
        merchantsCtrl.loading = true;
        merchantsCtrl.setPartnerSelect = '';
        merchantsCtrl.startSpin();
        merchantsCtrl.loadMerchantList();
        merchantsCtrl.setArrow('merchantName', false);
        merchantsCtrl.disableAnalyticsSelectDot = 'fa fa-circle';
        merchantsCtrl.disableAnalyticsSelectAll = true;
    };

    // When your view loads, so does its associated controller. Instead of using ng-init, simply call your init()
    // Since your controller runs before ng-init
    init();
});



// WEBPACK FOOTER //
// ./src/controllers/mastercard/merchants.controller.js